import CardSliderItem from './CardSliderItem'
export default CardSliderItem
